// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CartLinesList, { CartLinesListStyles } from "@insite/content-library/Components/CartLinesList";
import Loader from "@store/Library/Components/Toolkit/Loader";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useActiveCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import { useOnePageCheckout } from "@toolkit/Framework/Store/Toolkit/Pages/OnePageCheckout/OnePageCheckoutHooks";
import React, { FC, useState } from "react";

export interface OnePageCheckoutProductListProps extends WidgetProps {}

export interface OnePageCheckoutProductListStyles {
    orderLinesList?: CartLinesListStyles;
}

export const onePageCheckoutProductListStyles: OnePageCheckoutProductListStyles = {};

const styles = onePageCheckoutProductListStyles;

const OnePageCheckoutProductList: FC<OnePageCheckoutProductListProps> = () => {
    const { cartId } = useOnePageCheckout();
    const { value: cart } = useActiveCartState(cartId);
    const { showSavingsAmount, showSavingsPercent } = useSettingsCollection().productSettings;
    const [isCondensed, setIsCondensed] = useState(false);
    const promotionsDataView = useAppSelector(state =>
        cartId ? getPromotionsDataView(state, cartId) : getCurrentPromotionsDataView(state),
    );

    if (!cart || !cart.cartLines || !promotionsDataView.value) {
        return <Loader />;
    }

    return (
        <CartLinesList
            extendedStyles={styles.orderLinesList}
            cart={cart}
            promotions={promotionsDataView.value}
            isCondensed={isCondensed}
            onChangeIsCondensed={(event: React.SyntheticEvent<Element, Event>, value: boolean) => setIsCondensed(value)}
            editable={false}
            showSavingsAmount={showSavingsAmount}
            showSavingsPercent={showSavingsPercent}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutProductList,
    definition: {
        displayName: "Product List",
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;
